import { render, staticRenderFns } from "./UserNewSubscription.vue?vue&type=template&id=9b922d80"
import script from "./UserNewSubscription.vue?vue&type=script&lang=js"
export * from "./UserNewSubscription.vue?vue&type=script&lang=js"
import style0 from "./UserNewSubscription.vue?vue&type=style&index=0&id=9b922d80&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports